<script lang="ts">
    import type { OptionList } from '$saga/types/search.types';
    import SearchBar from '$saga/views/Search/SearchBar.svelte';

    export let defaultSportOptions: OptionList = [];
    export let defaultDestinationOptions: OptionList = [];
    export let defaultDurationMin: number;
    export let defaultDurationMax: number;
    export let defaultBudgetMin: number;
    export let defaultBudgetMax: number;
    export let defaultLevels: OptionList = [];
    export let defaultTags: OptionList = [];
    export let defaultTypes: OptionList = [];

    export let title: string;
</script>

<div
    class="absolute bottom-[220%] w-full p-l text-left text-[26px] font-semibold text-white backdrop-blur-[1px] desktop:bottom-[200%] desktop:left-[max(4rem,calc(50vw-656px))] desktop:max-w-[656px] desktop:px-0 desktop:text-4xl"
>
    <div class="absolute left-0 top-0 h-full w-full bg-black/70 blur-3xl"></div>
    <h1 class="relative z-10">
        {title}
    </h1>
</div>

<SearchBar
    {defaultDestinationOptions}
    {defaultSportOptions}
    {defaultBudgetMax}
    {defaultBudgetMin}
    {defaultDurationMax}
    {defaultDurationMin}
    {defaultLevels}
    {defaultTags}
    {defaultTypes}
    isHomePage
/>
